// extracted by mini-css-extract-plugin
export default {"root":"SearchFiltersPrimary_root__RCbBd","filters":"SearchFiltersPrimary_filters__jiKEG","searchPageFilter":"SearchFiltersPrimary_searchPageFilter__Wzhzt"};